import axios from "axios";
import env from "@/utils/env";
import store from "@/vuex/index";
import { Toast } from "vant";
import { getXAppNonce, getXAppSignature } from "./thirdRequest";
import DebugLog from "@/utils/log";
const product = process.env.NODE_ENV === "production";

const Axios = axios.create({
  baseURL: "",
  timeout: 10000,
  withCredentials: true,
});
function encodeQuery(params) {
  if (!params || !Object.keys(params).length) return "";
  return Object.keys(params)
    .map((key) => {
      if (params[key]) {
        return `${key}=${params[key]}`;
      }
    })
    .join("&");
}

const Request = (
  requestConfig = {
    method: "get",
  }
) => {
  return new Promise((resolve, reject) => {
    if (!product) {
      requestConfig.data = Object.assign({}, requestConfig.data);
    }
    const config = {
      method: requestConfig.method,
      headers: {
        "Content-Type": "application/json",
        "X-Ingeek-AppId": store.state?.env?.appId || "wxf7b95b7c62ccbe6e",
        "X-Ingeek-DeviceId": store.state?.env?.deviceId || "ingeek-web",
      },
      url:
        requestConfig.method === "post"
          ? requestConfig.url
          : `${requestConfig.url}?${encodeQuery(requestConfig.data)}`,
      data:
        requestConfig.method === "post" && requestConfig.data
          ? requestConfig.data
          : {},
    };
    if (env.isSVW) {
      const timestap = +new Date();
      // const timestap = 1740642891000;
      const nonce = getXAppNonce(timestap).slice(0, 6);
      // const nonce = 123460;

      config.headers = {
        "Content-Type": "application/json",
        "X-App-Signature": getXAppSignature(
          "0a9814264a7c8de07a922029efb3d39c",
          timestap,
          nonce,
          requestConfig.data
        ),
        "X-App-Timestamp": timestap,
        "X-App-Nonce": nonce,
        "X-App-DeviceId": "xxx",
      };
    } else {
      config.headers = {
        "Content-Type": "application/json",
        "X-Ingeek-AppId": store.state?.env?.appId || "wxf7b95b7c62ccbe6e",
        "X-Ingeek-DeviceId": store.state?.env?.deviceId || "ingeek-web",
      };
    }
    Axios(config)
      .then((res) => {
        if (res.data.code === 0) {
          resolve(res.data.data);
        } else {
          if (!config.data._hideToast) {
            Toast(res.data.message);
          }
          DebugLog.error(
            "---接口请求错误---",
            requestConfig,
            res.data,
            config.headers
          );
          reject(res.data);
        }
      })
      .catch((err) => {
        Toast(err.message);
        reject(err);
      });
  });
};

export default Request;
